<ul class="list-group list-group-flush text-nowrap" *ngIf="replacedParts.length > 0">
    <li class="list-group-item py-0 mt-2"><b>Replaces Parts</b><i class="text-info fa fa-info-circle ms-2"
           ngbTooltip="This Part replaces the following Obsolete Part Numbers"></i>
    </li>
    <li class="list-group-item p-0">
        <div class="d-flex flex-wrap">
            <small class="mx-2" *ngFor="let p of replacedParts; let i=index">
                {{p}}
            </small>
        </div>
    </li>
</ul>
